module.exports = __webpack_public_path__ + "img/Bear11.39bed95b.jpg";